<template>
  <section class="popup__button-wrapper">
    <div class="popup__buttons popup__buttons--col">
      <a class="popup__button popup__button--back" @click="closePopup">Ok! Volver a la página</a>
    </div>
  </section>
</template>
<script>
export default {
  methods: {
    closePopup() {
      this.$emit('closePopup');
    },
  },
};
</script>
